import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StatusTemplateEnum } from '../../shared/enum/status-template-enum';
import { ButtonPadraoComponent } from '../../shared/components/button-padrao/button-padrao.component';
import { TipoTemplateEnum } from '../../shared/enum/tipo-template.enum';
import { CanalTemplateEnum } from '../../shared/enum/canal-template.enum';
import { SelectMultipleComponent } from '../../shared/components/select-multiple/select-multiple.component';
import { ContaService } from '../../shared/service/conta.service';
import {SetorService} from '../../shared/service/setor.service';
import {Setor} from '../../shared/model/setor/setor.model';

@Component({
  selector: 'app-modal-filtro-template',
  standalone: true,
  imports: [
    ButtonPadraoComponent,
    SelectMultipleComponent
  ],
  templateUrl: './modal-filtro-template.component.html',
  styleUrls: ['./modal-filtro-template.component.css']
})
export class ModalFiltroTemplateComponent implements OnInit {

  private readonly dialog = inject(MatDialogRef<ModalFiltroTemplateComponent>);
  public readonly data = inject(MAT_DIALOG_DATA);
  private readonly contaService = inject(ContaService);
  private readonly setorService = inject(SetorService);

  listaStatus = [
    { nome: 'Ativo', valor: true },
    { nome: 'Inativo', valor: false }
  ];
  listaStatusMeta: any[] = Object.values(StatusTemplateEnum);
  listaTipo: any[] = Object.values(TipoTemplateEnum);
  listaCanal: any[] = [
    { nome: 'WhatsApp', valor: CanalTemplateEnum.WHATSAPP },
    { nome: 'SMS', valor: CanalTemplateEnum.SMS }
  ];
  contas: any[] = [];
  primeiraFiltragem = true
  setores: Setor[] = []

  filtro: {
    numero: any[],
    tipo: TipoTemplateEnum[],
    canal: any[],
    status: any[],
    statusMeta: StatusTemplateEnum[],
    setores: Setor[]
  } = {
    numero: [],
    tipo: [],
    canal: [],
    status: [],
    statusMeta: [],
    setores: []
  };

  ngOnInit() {
    this.buscarNumeros();
    this.buscarSetor()
    this.filtro = this.data?.filtro ?? {
      numero: [],
      tipo: [],
      canal: [],
      status: [],
      statusMeta: []
    };
    this.primeiraFiltragem = this.data.primeiraFiltragem

    this.filtro.tipo = this.filtro.tipo?.length
      ? this.listaTipo.filter(t => this.filtro.tipo.includes(t))
      : [];

    this.filtro.canal = this.filtro.canal?.length
      ? this.listaCanal.filter(c => this.filtro.canal.some((sel: any) => sel.valor === c.valor))
      : [];

    if (!this.filtro.status || this.filtro.status.length === 0 && this.primeiraFiltragem) {
      this.filtro.status = [this.listaStatus[0]];
    } else {
      const primeiro = this.filtro.status[0];
      if (typeof primeiro === 'object' && 'valor' in primeiro) {
        this.filtro.status = this.listaStatus.filter(st =>
          this.filtro.status.some((s: any) => s.valor === st.valor)
        );
      } else {
        this.filtro.status = this.listaStatus.filter(st =>
          this.filtro.status.includes(st.valor)
        );
      }
    }
    this.filtro.statusMeta = this.filtro.statusMeta?.length
      ? this.listaStatusMeta.filter(s => this.filtro.statusMeta.includes(s))
      : [];
  }

  buscarNumeros() {
    this.contaService.buscarTodosNumerosAtivos().subscribe({
      next: res => {
        this.contas = res;
        this.filtro.numero = this.contas.filter(n =>
          this.filtro.numero.map(n => n.id).includes(n.id)
        );
      }
    });
  }

  buscarSetor() {
    this.setorService.buscarSetoresSelectAtivo().subscribe({
      next: setores => {
        this.setores = setores
      }
    })
  }

  cancelar() {
    this.dialog.close();
  }

  filtrar() {
    this.filtro.status = this.filtro.status?.map(s => s.valor) ?? [];
    this.dialog.close(this.filtro);
  }
}
